export enum EndpointTypes {
  CHAT = 'CHAT',
  EMAIL = 'EMAIL',
  FB_MESSENGER = 'FB_MESSENGER',
  INSTAGRAM_COMMENT = 'INSTAGRAM_COMMENT',
  INSTAGRAM_DIRECT = 'INSTAGRAM_DIRECT',
  SMS = 'SMS',
  TWITTER = 'TWITTER',
  VOICE = 'VOICE',
  WHATSAPP = 'WHATSAPP',
  CUSTOM_CHANNEL = 'CUSTOM_CHANNEL',
}
